import { ApplicationRef, Injectable, Type } from '@angular/core';

import { ModalContainerComponent } from './modal-container/modal-container.component';
import { ModalOptions } from './models/modal-options.model';
import { ModalRef } from './models/modal-ref.model';
import { Modal } from './models/modal.model';

@Injectable()
export class ModalService {
  private modalContainer: HTMLElement;

  constructor(private appRef: ApplicationRef) {}

  open<T extends Modal>(
    component: Type<T>,
    inputs?: any,
    options?: ModalOptions
  ): ModalRef {
    this.setupModalContainerDiv();

    const modalContainerRef = this.appRef.bootstrap(
      ModalContainerComponent,
      this.modalContainer
    );

    const modalComponentRef = modalContainerRef.instance.createModal(
      component,
      options
    );

    if (inputs) {
      modalComponentRef.instance.onInjectInputs(inputs);
    }

    return new ModalRef(modalContainerRef, modalComponentRef);
  }

  private setupModalContainerDiv(): void {
    this.modalContainer = document.createElement('div');
    document.getElementsByTagName('body')[0].appendChild(this.modalContainer);
  }
}
